import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonGroup, Dropdown, Form } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import i18next from '../../translations/i18n';
import API from '../../services/API';
import { setSelectedFilters, setFilteredPosts } from '../../redux/slices';
import './index.scss';

const FilterComponent = () => {
  const dispatch = useDispatch();
  const assetClasses = useSelector((state) => state.app);
  const { stories = [], filters } = assetClasses;
  const [updateFilters, setUpdatedFilters] = useState(filters);
  const onChange = async (updatedFilter) => {
    await dispatch(setSelectedFilters(updatedFilter));
    await dispatch(setFilteredPosts(stories));
  };

  useEffect(() => {
    setUpdatedFilters(filters);
  }, [filters, stories]);

  return (
    <Dropdown as={ButtonGroup} autoClose="outside" className="filter_container">
      <Dropdown.Toggle
        id="dropdown-basic"
        variant="transparent"
        className="outline-teal border p-3"
      >
        <span className="filter__icon" />
        <Trans>{i18next.t('Filter')}</Trans>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Form>
          {updateFilters &&
            updateFilters.map((option, idx) => (
              <Dropdown.Item
                key={`${option.id}`}
                id={`${option.id}`}
                eventKey={idx}
                as="label"
                className="d-flex align-items-center m-0"
              >
                <Form.Group
                  className="dropdown-item mb-0"
                  controlId={option.id}
                >
                  <Form.Check
                    id={i18next.t(option.name)}
                    type="checkbox"
                    label={i18next.t(option.name)}
                    checked={option.checked}
                    onChange={(e) => {
                      e.preventDefault();
                      API.sendToGA(`Filter-${option.name}`);
                      onChange(option.id);
                    }}
                  />
                </Form.Group>
              </Dropdown.Item>
            ))}
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  );
};

FilterComponent.propTypes = {};
export default FilterComponent;
